import React, { Component } from 'react';
import _ from 'lodash';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { WithStyles, createStyles, Typography, Grid, TextField, Paper, Checkbox, RadioGroup, FormControlLabel, Radio, Button, MenuItem, OutlinedInput } from '@material-ui/core';
import { MyPATDialog, MyPATSelect, MyPATTextField, MyPATCollapse, MyPATMultiSearch, MyPATDropdown } from '../../common';
import cx from 'classnames';
import DeleteIcon from '@material-ui/icons/Delete';
import { TypeOfGoalBody } from '../types/TypeOfGoalBody';
import { TypeOfSubjectBody } from '../types/TypeOfSubjectBody';
import { ContentSubType } from '../types/ContentSubTypeBody';
import { getContentSubType } from '../actions/testTemplateActions';
import { TestTemplateBody, Section, SubSection } from '../types/TestTemplateBody';
import { testTemplateService } from '../services/testTemplateService';
import { toShowJEEMainSpecificFields, JEE_MAIN_COURSE_ID, getNoOfQuestionsToConsiderForMarks, OPTIONAL_SUPPORTED_COURSE_IDS, getPropertyValue, createDeepCopy } from '../../../utils';
import { KEY_CODE, QUESTION_TYPES, TEST_TEMPLATE_CONFIG, masterTestTypes } from '../../../constants/comman';



const styles = (theme: Theme) => createStyles({
    root: {
        ...theme.mixins.gutters(),
        width: '100%',
        maxWidth: '100%'
    },
    primaryColor: {
		color: 'rgb(29 125 234)'
	},
    radioFix: {
        width: '173px',
        'overflow': 'hidden',
    },
    'MuiFormControlLabel-label-278': {
        'width': '143px',
        'white-space': 'nowrap',
        'overflow': 'hidden',
        'text-overflow': 'ellipsis',
    },
    paddingT: {
        paddingTop: theme.spacing.unit * 2,
    },
    paddingB: {
        paddingBottom: theme.spacing.unit
    },
    fieldMarginBottom: {
        marginBottom: theme.spacing.unit * 3,
    },
    inputField:{
        marginBottom: 15,
        '& input':{
            borderColor: '#DFDFDF',
            fontSize: 14,
            color: '#666',
            height: 31,
        },
        '& p':{
            marginTop: 12,
            fontWeight: 400
        }
    },
    selectDropdown:{
        '& selectControl':{
            width: '100%'
        },
        '&>:nth-child(3)':{
            borderRadius: 6,
        },
        '& select':{
            width: '100%',
            maxWidth: '100%',
            color: '#666',
            fontSize: 14,
            height: 40,
            lineHeight: '24px',
            backgroundPositionX: '99%'
        }
    },
    textRight: {
        textAlign: 'right'
    },
    paperSection: {
        marginTop: theme.spacing.unit * 2,
        background: '#fff',
        boxShadow: 'none',
        border: 'solid 1px #E6E6E6',
    },
    floatRight: {
        float: "right"
    },
    verticalAlign: {
        verticalAlign: "top",
    },
    autoPickCheckbox: {
        verticalAlign: "top",
        paddingRight: 0,
        right: '-10px',
    },
    checkbox: {
		padding: theme.spacing.unit / 4,
		top: 0,
		left: 14,
		width: 20,
        height: 18,
        marginRight: 18,
		'-moz-appearance': 'none',
		opacity: 1,
		color: 'rgb(204, 204, 204)',
		backgroundColor: '#fff',
		border: '1px solid rgb(193 192 192)',
		borderRadius: 3,
		'& svg': {
			fontSize: '1.5rem',
			fontFamily: 'Nunito',
			fill: '#979797',
			opacity: 0
		}
	},
	checkedCheckbox: {
		backgroundColor: '#1d7dea',
		border: '1px solid #1d7dea',
		borderRadius: 2,
		color: '#99a1a7',
		'&::after': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 1,
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
    customCheckbox: {
		backgroundColor: '#1d7dea',
		border: '1px solid #1d7dea',
		borderRadius: 2,
		color: '#99a1a7',
		'&::after': {
			content: "''",
			fontSize: 14,
			position: 'absolute',
			top: 1,
			left: 6,
			width: 4,
			height: 10,
			border: 'solid #fff',
			borderWidth: '0 2px 2px 0',
			transform: 'rotate(45deg)'
		},
		'&:hover': {
			backgroundColor: '#1d7dea'
		}
	},
    paddingLeft: {
        paddingLeft: "5px"
    },
    grayTxt:{
        color: '#666'
    },
    paperSectionTitle: {
        padding: theme.spacing.unit * 2,
        borderBottom: '1px solid #E0E6E7',        
        '& h6': {
            fontWeight: 400,
            fontSize: 20,
            color: '#333'
        }
    },
    bglightGreen: {
        background: '#F4F8F9',
    },
    radiusTop4:{
        borderRadius: '4px 4px 0 0'
    },
    paperSectionContent: {
        padding: theme.spacing.unit * 2,
        background: theme.palette.background.default,
    },
    pa0:{
        padding: 0
    },
    paperSectionContent2: {
        padding: theme.spacing.unit * 2,
    },
    paperSectionContentInner: {
        marginTop: theme.spacing.unit * 2,
        padding: `${theme.spacing.unit * 2}px`,
        background: theme.palette.common.white,
        borderRadius: '2px',
        '&:first-child': {
            marginTop: `0px`,
        }
    },
    noCardShadow:{
        padding: 16,
        border: 0,
        boxShadow: 'none'
    },
    mb20:{
        marginBottom: 20,
    },
    deleteI: {
        fontSize: 20,
        float: "right",
        margin: '0px 0px 0px 5px'
    },
    questionType: {
        width: "140px",
        height: "35px",
    },
    formLabel: {
        fontSize: 14,
        lineHeight: '26px',
        color: '#333333',
        marginBottom: 10,
    },
    numS: {
        width: 110,
        height: 40,
        margin: 0,
        background: '#F4F4F4',
        paddingRight: 8,
        '& input': {
            padding: '3px 0px 2px 6px',
            width: 80,
            height: 32,
            background: 'rgb(255 255 255)',
            border: '1px solid rgb(223 223 223)',
            borderRadius: 4,
            textAlign: 'center'
        },
        "& input::-webkit-clear-button, & input::-webkit-outer-spin-button, & input::-moz-inner-spin-button, & input::-moz-outer-spin-button, & input::-webkit-inner-spin-button": {
            display: "block",
            height: 36,
            width: 24,
            padding: '0px 4px'
        },
        "& input[type=number]::-webkit-inner-spin-button, & input[type='number'].mod::-moz-inner-spin-button, input[type=number]::-webkit-outer-spin-button, & input[type='number'].mod::-moz-outer-spin-button": {
            opacity: 1,
        },
        "& input[type=number]":{
            '-moz-appearance': 'textfield'
        },
        '& positionEnd':{
            marginRight: 8,
        }
    },
    keyValueContainer: {
        '& *': {
            display: 'inline',
            marginRight: '4px',
        },
        '&>p': {
            padding: '4px 0',
            lineHeight: '30px'
        }
    },
    paperSubSectionQuestion: {
        paddingTop: theme.spacing.unit * 2,
        fontSize: '0.9rem'
    },
    paperSubSectionQuestionId: {
        opacity: 0.5,
    },
    num: {
        margin: "0px",
        width: "77px",
        height: "35px",
        marginTop: theme.spacing.unit,
        marginRight: theme.spacing.unit * 2
    },
    partialMarks: {
        '& *': {
            fontWeight: theme.typography.fontWeightMedium,
            fontSize: '1rem'
        }
    },
    checkB: {
        padding: "0px",
    },
    selectSection: {
        width: "170px",
        maxWidth: "180px",
        // height: "17px",
    },
    questionAttemptType: {
        marginLeft: '30px'
    },
    questionTS: {
        // height: "17px"
    },
    subSectionName: {
        height: "38px"
    },
    addSubSectionButton: {
        background: theme.palette.common.white,
        marginTop: theme.spacing.unit * 2,
        boxShadow: '0 0 10px 0 #0000001F'
    },
    sectionWidth: {
        width: "163px"
    },
    hidden:{
        opacity: 0.5
    },
    normalHeading:{
        fontSize: 14,
        fontWeight: 400,
        color: '#333',
        marginBottom: 12,
    },
    subText:{
        fontSize: 14,
        fontWeight: 400,
        color: '#666',
        marginBottom: 12,
    },
    testInfo:{
        display: 'flex',
        gap: '20px',
        marginTop: 15,
    },
    duration:{
        display: 'flex',
        alignItems: 'flex-end',
        gap: '20px',
        '&> p':{
            marginBottom: 15,
        },
    },
    hourDuration:{
        '&>:nth-child(2)':{
            marginBottom: 0,
        },
        '&> p':{
            marginBottom: 10,
        },
        '& select':{
            minWidth: 209,
        }
    },
    mt6:{
        marginTop: 8,
    },
    mypatDb:{
        borderRadius: 6
    },
    h36:{
        height: '36px !important',
    }
});


interface CreateTestTemplateProps extends WithStyles<typeof styles> {
    typeOfGoal: TypeOfGoalBody[],
    contentSubType: ContentSubType[],
    typeOfSubject: TypeOfSubjectBody[],
    transferToParent: (data: TestTemplateBody) => any,
    updateTemplate: TestTemplateBody,
    getContentSubType: Function,
    activeTSetting: any,
    isDisableForm: boolean;
}

interface CreateTestTemplateState {
    templateRequestBody: TestTemplateBody;
    defaultGoalVal: string;
    courseSyllabusList: any[];
}

enum QuestionAttemptType  {
    OPTIONAL = 'Optional',
    MANDATORY = 'Mandatory'
}



class CreateTestTemplate extends Component<CreateTestTemplateProps, CreateTestTemplateState>{

    templateSubSection: SubSection = {
        name: "",
        negativeMarks: 0,
        positiveMarks: 0,
        partialMarksAllowed: false,
        noOfQuestions: 1,
        quesCodeAllowed: -1,
        partialMarks: 0,
        instruction: "",
    }


    templateSection: Section = {
        courseSyllabusId: "",
        name: "",
        autoPickSelection: false,
        totalMarks: 0,
        subSection: [JSON.parse(JSON.stringify(this.templateSubSection))]
    }

    templateRequestB: TestTemplateBody = {
        testTemplateTypeId: "",
        _id: "",
        name: "",
        testTemplateId: "",
        testTemplateName: "",
        courseId: "",
        totalMarks: 0,
        questionsCount: 0,
        noOfSections: 1,
        subSectionsCount: 0,
        groupId: "",
        sections: [JSON.parse(JSON.stringify(this.templateSection))],
        testTypeCode: TEST_TEMPLATE_CONFIG.MASTER_TEST_TYPE[0],
        testDurationType: TEST_TEMPLATE_CONFIG.DURATION[0],
        testSectionLevel: TEST_TEMPLATE_CONFIG.SECTION_LEVEL[0],
        testDurationNumber: TEST_TEMPLATE_CONFIG.DEFAULT_TIME
    };

    newSectionCount: number = 1;

    constructor(props: CreateTestTemplateProps) {
        super(props);
        this.state = {
            templateRequestBody: this.templateRequestB,
            defaultGoalVal: "",
            courseSyllabusList: [],
        };

        if (!props.activeTSetting.testSection) {
            props.activeTSetting.testSection = "subject";
        }

        this.addSection = this.addSection.bind(this);
        this.changeSection = this.changeSection.bind(this);
        this.getCourseSyllabusName = this.getCourseSyllabusName.bind(this);
    }

    componentDidMount() {
        this.props.getContentSubType("question");
        if (this.props.updateTemplate) {
            let template = _.cloneDeep(this.props.updateTemplate);
            template.sections = template.sections.map(s => {
                if (!s.courseSyllabusId) {
                    s.courseSyllabusId = ""
                }
                if (s.courseSyllabusId._id) {
                    s.courseSyllabusId = s.courseSyllabusId._id;
                }
                return s;
            })
            if(!OPTIONAL_SUPPORTED_COURSE_IDS.includes(template.courseId )) {
                template.sections.forEach((section) => {
                    section.subSection.forEach(subSection => {
                        subSection.mandatoryQuestionCount = subSection.noOfQuestions;
                        subSection.optionalQuestions = false;
                    })
                })
            }
            template.testTypeCode = TEST_TEMPLATE_CONFIG.MASTER_TEST_TYPE.find(masterType => masterType.key === (template.testTypeCode || '').toLowerCase());
            template.testDurationType = TEST_TEMPLATE_CONFIG.DURATION.find(testDurationType => testDurationType.key === (template.testDurationType || '').toLowerCase());
            template.testSectionLevel = TEST_TEMPLATE_CONFIG.SECTION_LEVEL.find(sectionLevel => sectionLevel.key === (template.testSectionLevel || '').toLowerCase());
            template.goal = this.props.typeOfGoal.find(goal => goal.groupId === template.groupId);
            this.setState({
                templateRequestBody: template
            }, () => {
                this.getCourseSyllabus(TEST_TEMPLATE_CONFIG.GOAL.name, template.courseId);
            });
            this.newSectionCount = getPropertyValue(this.props, 'updateTemplate.sections.length') || 1;
        }
    }

    componentDidUpdate(prevProps: Readonly<CreateTestTemplateProps>, prevState: Readonly<CreateTestTemplateState>, prevContext: any): void {
        if (prevState.templateRequestBody !== this.state.templateRequestBody) {
            this.props.transferToParent({ ...this.state.templateRequestBody, ...this.state.templateRequestBody });
        }
    }

    componentWillReceiveProps() {
        this.setState({
            defaultGoalVal: this.props.typeOfGoal && this.props.typeOfGoal.length > 0 ? this.props.typeOfGoal[0]._id : ""
        });
    };

    updateSection = (i: number = 0, e: any) => {
        let { value } = e.target;
        let { templateRequestBody } = this.state;
        if (templateRequestBody.sections.length) {
            templateRequestBody.sections[i].name = value
            this.props.transferToParent(templateRequestBody);
            this.setState({ templateRequestBody })
        }
    }

    changeSection(e: any) {
        let c: any = !isNaN(parseInt(e.target.value)) ? parseInt(e.target.value) : "";
        let t: TestTemplateBody = this.state.templateRequestBody;
        if (c != "") {
            this.newSectionCount = (t.sections || []).length;
        }
        if (_.parseInt(c)) {
            if (_.parseInt(c) < 0) {
                c = 0;
                e.target.value = 0;
            }
        }
        t.noOfSections = c;
        this.setState({
            templateRequestBody: t
        });
    }

    changeSubSection = (i: any = "", j: any = "", keyName: any = "", e: any) => {
        let { name, value, checked } = e.target;
        value = checked ? checked : value;
        let t: any = this.state.templateRequestBody;
        let k = keyName.split('.');
        const subSection = t[k[0]][i][k[1]][j];
        
        /**@In_Progress noOfQuestions count functionality 
        let noOfQuestions = subSection['noOfQuestions']
        */


        if (value !== "" && parseFloat(value)) {
            if (parseFloat(value) < 0) {
                value = 0;
                e.target.value = 0;
            } else {
                value = parseFloat(value);
                e.target.value = value;
            }
        } else if (value === ""){
            value = 0;
            e.target.value = 0;
        }

        if(name === 'mandatoryQuestionCount' && value > subSection.noOfQuestions) {
            return;
        }
        
        if(name === 'noOfQuestions' && subSection.optionalQuestions === false) {
            subSection.mandatoryQuestionCount = value;
        } else if (name === 'noOfQuestions') {
            if(subSection.mandatoryQuestionCount !== undefined && value < subSection.mandatoryQuestionCount) {
                subSection.mandatoryQuestionCount = value;
            }
        }

        subSection[name] = value;

        /** @In_Progress noOfQuestions count functionality
         *  if(value == 5) {
            if(t._id) {
                noOfQuestions = noOfQuestions > 2 ? noOfQuestions : 2
            } else {
                noOfQuestions = 2
            }
        } else {
            if(t._id) {
                noOfQuestions = noOfQuestions > 1 ? noOfQuestions : 1
            } else {
                noOfQuestions = 1
            }
        } 
        
        subSection['noOfQuestions'] =  value == 5 ? 2 : 1

        */





        //negativeMarks should be less than positiveMarks
        //same goes for partial marks
        if (subSection.positiveMarks < subSection.negativeMarks) {
            subSection.negativeMarks = subSection.positiveMarks;
        }
        if (subSection.positiveMarks < subSection.partialMarks) {
            subSection.partialMarks = subSection.positiveMarks;
        }
        t[k[0]][i][k[1]][j] = subSection;
        this.setState({
            templateRequestBody: t
        });
        this.props.transferToParent(this.state.templateRequestBody);
    }

    addSection(e: any) {
        const newValue = +getPropertyValue(e, 'target.value', 0);
        const currentValue = getPropertyValue(this.state, 'templateRequestBody.sections.length', 0);
        if (newValue === currentValue) {
            return;
        }
        if (e.target.value >= 1 && e.target.value < 11) {
            let t: TestTemplateBody = this.state.templateRequestBody;
            let i: number = newValue - this.newSectionCount ;
            const { templateRequestBody: { courseId } } = this.state;
            const toAddJEEMainSpecificFields = courseId === JEE_MAIN_COURSE_ID;
            if (i > 0)
                for (let k = 0; k < i; k++) {
                    let newSection = JSON.parse(JSON.stringify(this.templateSection));
                    if(toAddJEEMainSpecificFields) {
                        newSection = this.toggleJEEMainSpecificFields([newSection], 'add')[0];
                    }
                    t.sections.push(newSection);
                }

            else
                for (let k = -1; k >= i; k--)
                    t.sections.pop();
            this.newSectionCount = t.sections.length
            this.setState({
                templateRequestBody: t
            });
        }
    }


    calculateMarks = () => {
        let temp: TestTemplateBody = this.state.templateRequestBody;
        let count: any;
        if (temp.sections && temp.sections.length > 0) {

            //Exctract all subsections length
            count = temp.sections && temp.sections.length > 0 ? temp.sections.map(o => o.subSection.length) : 0
            //Add all elements
            temp.subSectionsCount = count.reduce(function (a: any, b: any) { return a + b; }, 0);

            //Extract all questionsCount
            count = 0;
            count = temp.sections.map(o => {
                let t = 0;
                o.subSection.map((k: any) => t += parseInt(k.noOfQuestions))
                return t;
            });
            count = count.reduce(function (a: any, b: any) { return a + b; }, 0);
            temp.questionsCount = count;

            //Calculate totalMarks first
            count = 0;
            count = temp.sections.map((o, i) => {
                let t = 0;
                o.subSection.map(k => {
                    const { optionalQuestions, mandatoryQuestionCount, noOfQuestions } = k;
                    const noOfQuestionsToConsiderForMarks = optionalQuestions && mandatoryQuestionCount !== undefined ? mandatoryQuestionCount || 0 : noOfQuestions;
                    return t += k.positiveMarks * noOfQuestionsToConsiderForMarks
                });
                temp.sections[i].totalMarks = t;
                return t;
            });

            //Extract all totalMarks
            count = 0;
            count = temp.sections.map(o => {
                let t = 0;
                t += o.totalMarks;
                return t;
            });
            count = count.reduce(function (a: any, b: any) { return a + b; }, 0);
            temp.totalMarks = count;
        }
        this.setState({
            templateRequestBody: temp
        });
    }


    addSubSection = (i: any, e: any) => {
        let t: TestTemplateBody = this.state.templateRequestBody;
        const { templateRequestBody: { courseId } } = this.state;
        const toAddJEEMainSpecificFields = courseId === JEE_MAIN_COURSE_ID;
        let newSubSection: SubSection = JSON.parse(JSON.stringify(this.templateSubSection));
        if(toAddJEEMainSpecificFields) {
            newSubSection.optionalQuestions = false;
            newSubSection.mandatoryQuestionCount = newSubSection.noOfQuestions;
        }
        t.sections[i].subSection.push(newSubSection);
        this.setState({
            templateRequestBody: t
        });
    }


    updateTestTemplate = (i: any = "", j: any = "", keyName: any = "", e: any) => {
        let { name, value, checked, type } = i && i.target ? i.target : e.target;
        value = checked && type != "radio" ? checked : type == 'number' ? parseFloat(value) : value;
        let t: any = this.state.templateRequestBody;
        if (value) {
            if (value < 0) {
                value = 0;
                e.target.value = 0;
            }
        }

        if (keyName && i >= 0) {
            //Will be used for sub sections
            if (keyName.indexOf('.') > -1) {
                let k = keyName.split('.');
                t[k[0]][i][k[1]][j][name] = value;
            }
            //will be used for sections
            else {
                t[keyName][i][name] = value;
            }
        }
        else if (keyName) {
            t[keyName][name] = value;
        }
        else {
            t[name] = value;
        }
        //get if course has changed
        this.getCourseSyllabus(name, value);

        let newSections = t.sections;
        if(name === 'courseId' && value === JEE_MAIN_COURSE_ID && toShowJEEMainSpecificFields(t)) { // FOR JEE MAINS
            // Add mandatory and optional form fields in subSections
            newSections = this.toggleJEEMainSpecificFields(newSections, 'add')
        } else if(name === 'courseId') {
            // Remove mandatory and optional form fields in subSections
            newSections = this.toggleJEEMainSpecificFields(newSections, 'add')
        }
        t.sections = newSections;
        this.setState({
            templateRequestBody: t
        });
        this.calculateMarks();
        this.props.transferToParent(this.state.templateRequestBody);
    };

    

    toggleJEEMainSpecificFields = (sections: Section[], type: 'add' | 'remove') => {
        const newSections = sections.map((section: Section) => {
            const newSubSections = [...section.subSection].map((subSection: SubSection) => {
                const newSubSection = {...subSection}
                if(type === 'add') {
                    newSubSection.optionalQuestions = false;
                    newSubSection.mandatoryQuestionCount = newSubSection.noOfQuestions;
                } else {
                    delete newSubSection.optionalQuestions;
                    delete newSubSection.mandatoryQuestionCount;
                }
                return newSubSection;
            });
            section.subSection = newSubSections;
            return section;
        });
        return newSections;
    }

    // Prevent entering negative value
    preventNumberFormat = (evt: any) => {
        evt.charCode === KEY_CODE.ENTER && this.addSection(evt);
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if (charCode != 46 && charCode > 31
            && (charCode < 48 || charCode > 57))
            return false;
        return true;
    }

    onlyAllowWholeNumber = (evt: any) => {
        var theEvent = evt
        var key = theEvent.keyCode || theEvent.which;
        key = String.fromCharCode(key);

        var regex = /[0-9]/;
        if (!regex.test(key)) {
            theEvent.returnValue = false;
            if (theEvent.preventDefault) theEvent.preventDefault();
        }
    }

    deleteSubSection(e: any, i: number, j: number, keyName: string) {
        let t: any = this.state.templateRequestBody;
        if (keyName && i >= 0) {
            //Will be used for sub sections
            if (keyName.indexOf('.') > -1) {
                let k = keyName.split('.');
                t[k[0]][i][k[1]].splice(j, 1);
            }
        }
        this.setState({
            templateRequestBody: t
        });
        this.calculateMarks();
        this.props.transferToParent(this.state.templateRequestBody);
    }

    getCourseSyllabus(name: string, value: string) {
        if (name != "courseId") {
            return;
        }

        const activeTestSetting = this.getActiveTestSetting();
        testTemplateService.getAllSyllabus(value, activeTestSetting.testSection).then(res => {
            this.setState({ courseSyllabusList: res });
        })
    }

    getActiveTestSetting = () => {
        const { templateRequestBody } = this.state;
        return ({
            code: getPropertyValue(templateRequestBody, 'testTypeCode.key', ''),
            testSection: getPropertyValue(templateRequestBody, 'testSectionLevel.key', ''),
        });
    }

    getCourseSyllabusName() {
        const activeTSetting = this.getActiveTestSetting();
        activeTSetting.testSection = (activeTSetting.testSection ? activeTSetting.testSection : "subject")
        if (activeTSetting.testSection == "subject") {
            return "Subject";
        }
        else if (activeTSetting.testSection == "sub-subject") {
            return "Subsubject";
        }
        else if (activeTSetting.testSection == "chapter") {
            return "Chapter";
        }
        else if (activeTSetting.testSection == "concept") {
            return "Concept";
        }
        return "";
    }

    handleQuestionAttemptTypeChange = (e: any, i: number, j:number) => {
        const questionAttemptType = e.target.value;
        this.setState(prevState => {
            const newSections = [...prevState.templateRequestBody.sections];
            const newSection = {...newSections[i]};
            const newSubSections = [...newSection.subSection];
            const newSubSection = {...newSubSections[j]};
            newSubSection.optionalQuestions = questionAttemptType === QuestionAttemptType.OPTIONAL ? true : false;
            newSubSection.mandatoryQuestionCount = questionAttemptType === QuestionAttemptType.MANDATORY ? newSubSection.noOfQuestions : newSubSection.mandatoryQuestionCount
            newSubSections[j] = newSubSection;
            newSection.subSection = newSubSections;
            newSections[i] = newSection;
            return {
                ...prevState,
                templateRequestBody: {
                    ...prevState.templateRequestBody,
                    sections: newSections
                }
            }
        }, () => {
            this.props.transferToParent(this.state.templateRequestBody);
        })
    }

    getMarksOfSections = (sections: Section[]) => {
        return sections.reduce((total, { subSection }) => {
            const subSectionTotal = subSection.reduce((acc, { mandatoryQuestionCount, noOfQuestions, positiveMarks }) => {
                const quesCountForMarks = mandatoryQuestionCount !== undefined ? mandatoryQuestionCount : noOfQuestions;
                acc = acc + positiveMarks * (quesCountForMarks);
                return acc;
            }, 0)
            return total + subSectionTotal;
        }, 0)
    }

    /** @In_Progress noOfQuestions count functionality 
      getMinQuestions(quesCodeAllowed: string|number) {
       if(quesCodeAllowed == 5) {
           return '2'
       } 
       return '1'
   }
     * */

    handleGoalSelect = (selectedGoal: any) => {
        const { templateRequestBody } = this.state;
        if (getPropertyValue(templateRequestBody, 'courseId') === getPropertyValue(selectedGoal, 'groupId')) {
            return;
        }
        this.handleTemplateConfigSelected(TEST_TEMPLATE_CONFIG.FIELDS.GOAL, selectedGoal);
        this.updateTestTemplate('', '', '', { target: { value: (getPropertyValue(selectedGoal, 'groupId') ||  getPropertyValue(selectedGoal, '_id')), ...TEST_TEMPLATE_CONFIG.GOAL } });
        this.resetSectionsCourseId();
    }

    resetSectionsCourseId = () => {
        const newTemplateBody = createDeepCopy(this.state.templateRequestBody);
        (newTemplateBody.sections || []).forEach((section: any) => section.courseSyllabusId = '');
        this.setState({ templateRequestBody: { ...newTemplateBody } });
    }

    handleTemplateConfigSelected = (keyName: string, selectedItem: any) => {
        const { templateRequestBody } = this.state;
        if (getPropertyValue(templateRequestBody, keyName) === selectedItem) {
            return;
        }
        this.setState({ templateRequestBody: { ...this.state.templateRequestBody, [keyName]: selectedItem } }, () => {
            if (keyName === TEST_TEMPLATE_CONFIG.FIELDS.SECTION_LEVEL && selectedItem) {
                this.getCourseSyllabus(TEST_TEMPLATE_CONFIG.GOAL.name, getPropertyValue(this.state.templateRequestBody, 'courseId'));
                this.resetSectionsCourseId();
            }
        });
    }

    render() {
        const { classes, typeOfGoal, typeOfSubject, contentSubType, isDisableForm } = this.props;
        const { templateRequestBody, defaultGoalVal, courseSyllabusList } = this.state;
        const showJEEMAINSpecificFields = toShowJEEMainSpecificFields(templateRequestBody)
        const goalList = typeOfGoal.map(goal => ({ ...goal, name: getPropertyValue(goal, 'courseType.name') }));
        const activeGoal = typeOfGoal.find(goal => goal._id === templateRequestBody.courseId);
        const activeTSetting = this.getActiveTestSetting();
        return (
            <>
                <form>
                    <Grid item>
                        <Paper className={classes.paperSection}>
                            <div className={[classes.paperSectionTitle, classes.bglightGreen, classes.radiusTop4].join(' ')}>
                                <Grid container>
                                    <Grid item xs>
                                        <Typography variant="h6">Basic Details</Typography>
                                    </Grid>
                                    <Grid item xs="auto">
                                        <div className={classes.keyValueContainer}>
                                            <Typography variant="body1">
                                                Total Marks: {this.getMarksOfSections(templateRequestBody.sections)}
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </div>

                            <div className={`${classes.paperSectionContent2} ${isDisableForm && classes.hidden}`}>
                                <Grid container alignItems="center">
                                    <Grid item xs={12}>
                                        <Typography variant="body1" className={classes.normalHeading}>Template Name</Typography>
                                    </Grid>

                                    <Grid item xs={12} className={classes.inputField}>
                                        <MyPATTextField
                                            inputId="name"
                                            name="name"
                                            value={
                                                !_.isEmpty(templateRequestBody.name) ? templateRequestBody.name : ""
                                            }
                                            onChange={this.updateTestTemplate.bind(this, "", "", "")}
                                            fullWidthControl
                                            helperText="This name will show as template name in template"
                                            placeholder="Enter Name"
                                            disabled={isDisableForm}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Typography variant="body1" className={classes.normalHeading}>Select Goal</Typography>
                                        <Grid item xs={12} className={classes.selectDropdown}>
                                            <MyPATDropdown
                                                placeholder='Select Goal'
                                                dropdownItems={goalList}
                                                selectedItem={templateRequestBody.goal}
                                                onChange={this.handleGoalSelect}
                                                labelKey='name'
                                                valueKey='id'
                                                isCustomCss={true}
                                                enableSearch
                                                searchPlaceholder='Search Goal name'
                                                customSelectedOption={getPropertyValue(activeGoal, 'courseType.name')}
                                                fromTestTemplate={true}
                                            />
                                        </Grid>
                                        <Grid item className={classes.testInfo}>
                                            <Grid className={classes.duration}>
                                                <Grid className={classes.hourDuration}>
                                                    <Typography variant="body2">Test Duration</Typography>
                                                    <MyPATTextField
                                                        className={classes.numS}
                                                        value={templateRequestBody.testDurationNumber}
                                                        type="number"
                                                        margin="none"
                                                        variant="outlined"
                                                        onChange={(event: any) => this.setState({ templateRequestBody: { ...this.state.templateRequestBody, testDurationNumber: (+getPropertyValue(event, 'target.value', 0)) } })}
                                                    />
                                                </Grid>
                                                <MyPATDropdown
                                                    placeholder='Select Test Duration'
                                                    dropdownItems={TEST_TEMPLATE_CONFIG.DURATION}
                                                    selectedItem={templateRequestBody.testDurationType}
                                                    onChange={(selectedItem: any) => this.handleTemplateConfigSelected(TEST_TEMPLATE_CONFIG.FIELDS.DURATION, selectedItem)}
                                                    labelKey='name'
                                                    valueKey='id'
                                                    isCustomCss={true}
                                                    disabled={TEST_TEMPLATE_CONFIG.DURATION.length < 2}
                                                    customSelectedOption={getPropertyValue(templateRequestBody, 'testDurationType.name',)}
                                                    fromTestTemplate={true}
                                                />
                                            </Grid>
                                            <Grid className={classes.hourDuration}>
                                                <Typography variant="body2">Master Test Type</Typography>
                                                <MyPATDropdown
                                                    placeholder='Select Master Type'
                                                    dropdownItems={TEST_TEMPLATE_CONFIG.MASTER_TEST_TYPE}
                                                    selectedItem={templateRequestBody.testTypeCode}
                                                    onChange={(selectedItem: any) => this.handleTemplateConfigSelected(TEST_TEMPLATE_CONFIG.FIELDS.MASTER_TEST_TYPE, selectedItem)}
                                                    labelKey='name'
                                                    valueKey='id'
                                                    isCustomCss={false}
                                                    customSelectedOption={getPropertyValue(templateRequestBody, 'testTypeCode.name')}
                                                    fromTestTemplate={true}      
                                                    style={{ width: '300px' }}                                          
                                                />
                                            </Grid>
                                            <Grid className={classes.hourDuration}>
                                                <Typography variant="body2">Section Level</Typography>
                                                <MyPATDropdown
                                                    placeholder='Select Section Level'
                                                    dropdownItems={TEST_TEMPLATE_CONFIG.SECTION_LEVEL}
                                                    selectedItem={templateRequestBody.testSectionLevel}
                                                    onChange={(selectedItem: any) => this.handleTemplateConfigSelected(TEST_TEMPLATE_CONFIG.FIELDS.SECTION_LEVEL, selectedItem)}
                                                    labelKey='name'
                                                    valueKey='id'
                                                    isCustomCss={true}
                                                    customSelectedOption={getPropertyValue(templateRequestBody, 'testSectionLevel.name')}
                                                    fromTestTemplate={true}
                                                />
                                            </Grid>
                                            <Grid className={classes.hourDuration}>
                                                <Typography variant="body2">Number of Section</Typography>
                                                <MyPATTextField
                                                    className={classes.numS}
                                                    value={
                                                        templateRequestBody.noOfSections
                                                    }
                                                    onChange={this.changeSection}
                                                    onBlur={this.addSection}
                                                    id="numberSection"
                                                    type="number"
                                                    onKeyPress={this.preventNumberFormat.bind(this)}
                                                    margin="none"
                                                    onIncrementDecrement={this.addSection}
                                                    disabled={isDisableForm}
                                                    variant="outlined" />
                                            </Grid>
                                        </Grid>
                                      {  /*    <RadioGroup
                                            id="goalSelect"
                                            name="courseId"
                                            value={
                                                !_.isEmpty(templateRequestBody.courseId) ? templateRequestBody.courseId : ""
                                            }
                                            row
                                        >
                                            {
                                                _.map(typeOfGoal, (goal, i) => {
                                                    return (
                                                        <FormControlLabel className={classes.radioFix}
                                                            control={<Radio color="primary" />}
                                                            label={goal.courseType.name}
                                                            key={`${goal._id} ${i}`}
                                                            onChange={this.updateTestTemplate.bind(this, "", "", "")}
                                                           
                                                            value={
                                                                !_.isEmpty(goal.groupId) ? goal.groupId : ""
                                                            }
                                                        />
                                                    )
                                                })
                                            }
                                        </RadioGroup> */} 
                                    </Grid>
                                </Grid>
                            </div>
                        </Paper>
                        {/* <MyPATCollapse> */}
                        {
                            _.map(templateRequestBody.sections, (section, i) => {
                                return (
                                    <Grid>
                                        <Paper key={i} className={classes.paperSection}>
                                            <div className={`${[classes.paperSectionTitle, classes.bglightGreen, classes.radiusTop4].join(' ')} ${isDisableForm && classes.hidden}`}>
                                                <div className={classes.keyValueContainer}>
                                                    <Grid container>
                                                        <Grid item xs={4}>
                                                            <Typography variant="h6">Section {i + 1}:</Typography>
                                                            {
                                                                activeTSetting.testSection != "none" && (
                                                                    <MyPATSelect
                                                                        classes={{ input: classes.selectSection }}
                                                                        label=""
                                                                        inputId="subject"
                                                                        value={
                                                                            !_.isEmpty(section.courseSyllabusId) ? section.courseSyllabusId : ""
                                                                        }
                                                                        disabled={(section.autoPickSelection == true || isDisableForm) ? true : false}
                                                                        onChange={this.updateTestTemplate.bind(this, i, "", "sections")}
                                                                        name="courseSyllabusId"
                                                                    >
                                                                        <option key="-1" value="">Choose {this.getCourseSyllabusName()}</option>

                                                                        {
                                                                            _.map(courseSyllabusList, (cs, index) => {
                                                                                return (
                                                                                    <option key={`${cs._id} ${index}`} value={cs._id}>{cs.name}</option>
                                                                                )
                                                                            })
                                                                        }
                                                                    </MyPATSelect>
                                                                )
                                                            }
                                                            {
                                                                activeTSetting.testSection == "none" && (
                                                                    <MyPATTextField
                                                                        classes={{ input: classes.selectSection }}
                                                                        value={
                                                                            !_.isEmpty(section.name) ? section.name : ""
                                                                        }
                                                                        onChange={this.updateTestTemplate.bind(this, i, "", "sections")}
                                                                        id="sectionName"
                                                                        name="name"
                                                                        margin="none"
                                                                        disabled={isDisableForm}
                                                                        variant="outlined" />
                                                                )
                                                            }
                                                        </Grid>
                                                        <Grid item xs={1}>
                                                            {
                                                                activeTSetting.testSection != "none" && (
                                                                    <Typography variant="body2" className={[classes.paddingLeft, classes.grayTxt].join(' ')}>OR</Typography>
                                                                )
                                                            }
                                                        </Grid>

                                                        <Grid item xs={4}>
                                                            {
                                                                activeTSetting.testSection != "none" && (
                                                                    <FormControlLabel
                                                                        className={cx(classes.paddingLeft, classes.verticalAlign)}
                                                                        control={
                                                                            <Checkbox
                                                                                classes={{
                                                                                    colorPrimary: classes.primaryColor
                                                                                }}
                                                                                className={classes.autoPickCheckbox}
                                                                                name="autoPickSelection"
                                                                                onChange={this.updateTestTemplate.bind(this, i, "", "sections")}
                                                                                checked={
                                                                                    section.autoPickSelection ? section.autoPickSelection : false
                                                                                }
                                                                                color="primary"
                                                                                disabled={(section.courseSyllabusId != '' || isDisableForm) ? true : false}
                                                                            />
                                                                        }
                                                                        label="Any Topic"
                                                                    />
                                                                )
                                                            }
                                                        </Grid>
                                                        <Grid item xs={3}>
                                                            <Typography variant="body1" style={{ paddingTop: "8px" }} className={cx(classes.floatRight)}>Section Marks: {this.getMarksOfSections([section])}
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid container>
                                                        <Grid item xs={3}>
                                                            <MyPATTextField
                                                                classes={{ input: [classes.sectionWidth, classes.h36].join(' ') }}
                                                                value={section.name}
                                                                onChange={this.updateSection.bind(this, i)}
                                                                id="sectionName"
                                                                name="name"
                                                                margin="none"
                                                                disabled={section.courseSyllabusId != '' ? true : false}
                                                                variant="outlined" />
                                                        </Grid>
                                                    </Grid>
                                                </div>
                                            </div>
                                            <div className={[classes.paperSectionContent, classes.pa0].join(' ')}>
                                                {
                                                    _.map(section.subSection, (subSection, j) => {
                                                        const { optionalQuestions } = subSection
                                                        const noOfQuestionsToConsiderForMarks = getNoOfQuestionsToConsiderForMarks(subSection)
                                                        return (
                                                            <Paper key={j} className={classes.noCardShadow} elevation={1}>
                                                                {/* Question description */}
                                                                <Grid container>
                                                                    <Grid container className={classes.mb20}>
                                                                        <Grid item xs={8}>
                                                                            <MyPATTextField
                                                                                className={[classes.subSectionName, isDisableForm ? classes.hidden : ''].join(' ')}
                                                                                value={
                                                                                    !_.isEmpty(subSection.name) ? subSection.name : ""
                                                                                }
                                                                                onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                                id="subSectionName"
                                                                                name="name"
                                                                                margin="none"
                                                                                disabled={isDisableForm}
                                                                                variant="outlined" />
                                                                            {(
                                                                                <MyPATSelect
                                                                                    classes={{ input: [classes.selectSection, classes.questionAttemptType, isDisableForm ? classes.hidden : ''].join(" ") }}
                                                                                    label=""
                                                                                    inputId="questionAttemptType"
                                                                                    value={optionalQuestions ? QuestionAttemptType.OPTIONAL : QuestionAttemptType.MANDATORY}
                                                                                    onChange={(e: any) => this.handleQuestionAttemptTypeChange(e, i, j)}
                                                                                    name="questionAttemptType"
                                                                                    disabled={isDisableForm}
                                                                                >
                                                                                    <option value={QuestionAttemptType.MANDATORY}>Mandatory</option>
                                                                                    {OPTIONAL_SUPPORTED_COURSE_IDS.includes(templateRequestBody.courseId) && <option value={QuestionAttemptType.OPTIONAL}>Optional</option>}
                                                                                </MyPATSelect>
                                                                            )}
                                                                        </Grid>
                                                                        <Grid item xs={4}>
                                                                            <Typography variant="body1" className={cx(classes.textRight, classes.mt6, isDisableForm && classes.hidden)}>
                                                                                Sub-Section Marks: {noOfQuestionsToConsiderForMarks * subSection.positiveMarks}
                                                                                {
                                                                                    (section && section.subSection && section.subSection.length > 1) ?
                                                                                        <DeleteIcon className={classes.deleteI} onClick={(e: any) => { this.deleteSubSection(e, i, j, 'sections.subSection') }} />
                                                                                        :
                                                                                        ""

                                                                                }
                                                                            </Typography>
                                                                        </Grid>
                                                                    </Grid>
                                                                    <Grid item xs={3}>
                                                                        <Typography variant="body1" className={cx(isDisableForm && classes.hidden || classes.formLabel)}>Question Type:</Typography>
                                                                        <MyPATSelect
                                                                            label=""
                                                                            inputId="quesCodeAllowed"
                                                                            name="quesCodeAllowed"
                                                                            onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                            value={
                                                                                subSection.quesCodeAllowed != -1 ? subSection.quesCodeAllowed : -1
                                                                            }
                                                                            classes={{ input: classes.questionTS }}
                                                                            disabled={isDisableForm}
                                                                        >
                                                                            <option key="-1" value="">Choose:</option>

                                                                            {_.map(contentSubType, (questionType, index) => {
                                                                                if(showJEEMAINSpecificFields && (questionType.code.toString() === QUESTION_TYPES.PARAGRAPH.toString() || questionType.code.toString() === QUESTION_TYPES.DESCRIPTIVE.toString())) {
                                                                                    return null;
                                                                                }
                                                                                return (
                                                                                    <option key={`${questionType._id} ${index}`} value={questionType.code}>{questionType.name}</option>
                                                                                )
                                                                            })}
                                                                        </MyPATSelect>
                                                                    </Grid>
                                                                    {(
                                                                        <>
                                                                            <Grid item xs>
                                                                                <Typography variant="body1" className={cx(classes.formLabel, isDisableForm && classes.hidden)}>Total Ques:</Typography>
                                                                                <MyPATTextField
                                                                                    className={[classes.numS, isDisableForm ? classes.hidden : ''].join(' ')}
                                                                                    type="number"
                                                                                    onKeyPress={this.onlyAllowWholeNumber}
                                                                                    margin="none"
                                                                                    value={
                                                                                        subSection.noOfQuestions
                                                                                    }
                                                                                    inputProps={{ min: "1", step: "1" }}
                                                                                    onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                                    onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                                    name="noOfQuestions"
                                                                                    variant="outlined"
                                                                                    disabled={isDisableForm}
                                                                                /** @TODO implement min 2 question functionality later 
                                                                                 helperText={`Min 2 Questions`} */ />
                                                                            </Grid>
                                                                            <Grid item xs>
                                                                                <Typography variant="body1" className={cx(classes.formLabel, isDisableForm && classes.hidden)}>Mandatory:</Typography>
                                                                                <MyPATTextField
                                                                                    className={[classes.numS, isDisableForm ? classes.hidden : ''].join(' ')}
                                                                                    type="number"
                                                                                    onKeyPress={this.onlyAllowWholeNumber}
                                                                                    margin="none"
                                                                                    value={
                                                                                        subSection.mandatoryQuestionCount || subSection.noOfQuestions
                                                                                    }
                                                                                    inputProps={{ min: "1", step: "1", max: subSection.noOfQuestions }}
                                                                                    onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                                    onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                                    name="mandatoryQuestionCount"
                                                                                    variant="outlined"
                                                                                    disabled={isDisableForm || !optionalQuestions}
                                                                                /** @TODO implement min 2 question functionality later 
                                                                                 helperText={`Min 2 Questions`} */ />
                                                                            </Grid>
                                                                        </>
                                                                    )}        
                                                                    <Grid item xs>
                                                                        <Typography variant="body1" className={classes.formLabel}>Positive Marks:</Typography>
                                                                        <MyPATTextField
                                                                            className={classes.numS}
                                                                            type="number"
                                                                            onKeyPress={this.preventNumberFormat.bind(this)}
                                                                            margin="none"
                                                                            value={
                                                                                subSection.positiveMarks
                                                                            }
                                                                            onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                            onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                            name="positiveMarks"
                                                                            variant="outlined" />
                                                                    </Grid>
                                                                    <Grid item xs>
                                                                        <Typography variant="body1" className={classes.formLabel}>Negative Marks:</Typography>
                                                                        <MyPATTextField
                                                                            className={classes.numS}
                                                                            type="number"
                                                                            onKeyPress={this.preventNumberFormat.bind(this)}
                                                                            margin="none"
                                                                            value={
                                                                                subSection.negativeMarks
                                                                            }
                                                                            onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                            onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                            name="negativeMarks"
                                                                            variant="outlined" />
                                                                    </Grid>
                                                                    {/* {!showJEEMAINSpecificFields && (
                                                                        <Grid item xs>
                                                                            <Typography variant="body1" className={cx(classes.formLabel,isDisableForm && classes.hidden)}>No of questions:</Typography>
                                                                            <MyPATTextField
                                                                                className={classes.numS}
                                                                                type="number"
                                                                                onKeyPress={this.onlyAllowWholeNumber}
                                                                                margin="none"
                                                                                value={
                                                                                    subSection.noOfQuestions
                                                                                }
                                                                                inputProps={{ min: "1", step: "1" }}
                                                                                onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                                onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                                name="noOfQuestions"
                                                                                variant="outlined"
                                                                                disabled={isDisableForm}
                                                                                // @TODO implement min 2 question functionality later 
                                                                                // helperText={`Min 2 Questions`}  
                                                                        </Grid>
                                                                    )} */}
                                                                    <Grid item xs>
                                                                        <Grid item className={classes.formLabel}>
                                                                            <FormControlLabel
                                                                                control={
                                                                                    <Checkbox
                                                                                    classes={{
                                                                                        root: classes.checkbox,
                                                                                        checked: classes.checkedCheckbox,
                                                                                        colorPrimary: classes.primaryColor
                                                                                    }}
                                                                                        name="partialMarksAllowed"
                                                                                        onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                                        checked={
                                                                                            subSection.partialMarksAllowed ?
                                                                                                subSection.partialMarksAllowed : false
                                                                                        }
                                                                                        color="primary"
                                                                                    />
                                                                                }
                                                                                label="Partial Marks:"
                                                                            />
                                                                        </Grid>
                                                                        <MyPATTextField
                                                                            className={classes.numS}
                                                                            type="number"
                                                                            onKeyPress={this.preventNumberFormat.bind(this)}
                                                                            margin="none"
                                                                            onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                            onBlur={this.updateTestTemplate.bind(this, i, j, "sections.subSection")}
                                                                            name="partialMarks"
                                                                            value={
                                                                                subSection.partialMarks
                                                                            }
                                                                            variant="outlined" />
                                                                    </Grid>

                                                                    <Grid item xs={12}>
                                                                        <Typography 
                                                                        className={`${classes.paddingT} 
                                                                        ${classes.formLabel} 
                                                                        ${isDisableForm && classes.hidden}`}>
                                                                            Add Custom Instruction
                                                                        </Typography>
                                                                        <MyPATTextField
                                                                            inputId="instruction"
                                                                            rows="5"
                                                                            name="instruction"
                                                                            onChange={this.changeSubSection.bind(this, i, j, "sections.subSection")}
                                                                            multiline
                                                                            value={
                                                                                !_.isEmpty(subSection.instruction) ? subSection.instruction : ""
                                                                            }
                                                                            fullWidthControl
                                                                            disabled={isDisableForm}
                                                                            placeholder=" Write here.." />
                                                                    </Grid>
                                                                </Grid>
                                                            </Paper>
                                                        )
                                                    })
                                                }
                                            </div>
                                        </Paper>
                                        <Grid container>
                                            <Grid item xs={12} className={cx(classes.textRight)}>
                                                <Button className={classes.addSubSectionButton}
                                                    onClick={this.addSubSection.bind(this, i)}
                                                    disabled={isDisableForm}
                                                    variant="outlined">
                                                    Add Subsection
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                )
                            })
                        }
                    </Grid>
                </form>
            </>
        );
    }
}

const mapStateToProps = (state: any) => ({
    // map state to props here
    typeOfGoal: _.get(state, 'testTemplate.goal.list', {}),
    typeOfSubject: _.get(state, 'testTemplate.subject.list', {}),
    contentSubType: _.get(state, 'testTemplate.contentSubType.list', {})
}
);

const mapDispatchToProps = (dispatch: any) => bindActionCreators(
    {
        getContentSubType,
    },
    dispatch
);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(CreateTestTemplate));